import apiClient from './api';

// واجهة لتمثيل بيانات الملف المرفوع التي يعيدها الخادم
export interface UploadedFile {
  fieldname: string;
  originalname: string;
  encoding: string;
  mimetype: string;
  destination: string;
  filename: string;
  path: string;
  size: number;
  url: string; // أهم خاصية نحتاجها
}

/**
 * دالة لرفع مجموعة من الملفات
 * @param files - قائمة الملفات من حقل الإدخال <input type="file">
 * @returns مصفوفة من بيانات الملفات المرفوعة
 */
export const uploadMultipleFiles = async (files: FileList): Promise<UploadedFile[]> => {
  const formData = new FormData();
  
  // إضافة كل ملف إلى كائن FormData
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]); // يجب أن يتطابق 'files' مع اسم الحقل في multer
  }

  // إرسال الطلب مع تغيير رأس Content-Type
  const response = await apiClient.post<{ data: { files: UploadedFile[] } }>(
    '/upload/multiple', // أو /upload/documents إذا كنت تفضل
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data.data.files;
};
